import { getLineupServerSideProps } from 'utils/lineup.ssr.utils';

import type { NextPageWithLayout } from 'pages/_app';

import LineupLayout from 'components/@lineup/LineupLayout';
import LineupStandardTimeTableContainer from 'components/@lineup/LineupStandardTimeTableContainer';

/** The timetable view of a standard lineup. */
const EventLineupTimetablePage: NextPageWithLayout = () => (
  <LineupStandardTimeTableContainer />
);

EventLineupTimetablePage.getLayout = (page) => (
  <LineupLayout>{page}</LineupLayout>
);

export { getLineupServerSideProps as getServerSideProps };

export default EventLineupTimetablePage;
